/**
 * Hook for managing recording elapsed time
 * Timer only runs when recording, not initializing, and not paused
 */

import { useCallback, useEffect, useState } from 'react';

export function useRecordingTimer(isRecording: boolean, isInitializing: boolean, isPaused = false) {
  const [elapsedTime, setElapsedTime] = useState(0);

  // Timer logic - only run after initialization completes and when not paused
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isRecording && !isInitializing && !isPaused) {
      interval = setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRecording, isInitializing, isPaused]);

  const resetTimer = useCallback(() => {
    setElapsedTime(0);
  }, []);

  return {
    elapsedTime,
    setElapsedTime,
    resetTimer,
  };
}
